/**
 * @generated SignedSource<<b79890aca098895f476d4c69405f2d43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type entityLinkHeaderFeaturesArticle$data = {
  readonly authors: ReadonlyArray<{
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null | undefined> | null | undefined;
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name?: string;
      readonly published?: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "entityLinkHeaderFeaturesArticle";
};
export type entityLinkHeaderFeaturesArticle$key = {
  readonly " $data"?: entityLinkHeaderFeaturesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"entityLinkHeaderFeaturesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "entityLinkHeaderFeaturesArticle"
};

(node as any).hash = "0b1127378b1980c2149b775f8d712f3d";

export default node;
